import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = { class: "flex items-center justify-between px-4 py-3 gap-[10px]" }
const _hoisted_4 = { class: "flex items-center gap-[10px] flex-[1_0_0]" }
const _hoisted_5 = {
  key: 0,
  class: "shrink-0 flex items-center justify-center"
}
const _hoisted_6 = { class: "text-white font-['Inter'] text-base font-bold leading-6 tracking-[0.08px]" }
const _hoisted_7 = {
  key: 0,
  class: "shrink-0 flex items-center justify-center scale-90 pt-1"
}
const _hoisted_8 = { class: "flex flex-col items-start w-full" }
const _hoisted_9 = { class: "flex items-center gap-[10px] w-full justify-start mb-2" }
const _hoisted_10 = { class: "text-white font-semibold text-sm tracking-[0.01em] opacity-[0.88]" }
const _hoisted_11 = { class: "flex items-center justify-start rounded-lg px-[8px] pt-[3px] pb-[4px] w-full border border-white/10 backdrop-blur-sm bg-[#FCE9EA]/[0.24] text-center" }
const _hoisted_12 = { class: "m-0 text-white font-['Inter'] text-[12.5px] font-medium leading-[1.5] tracking-[0.01em]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex flex-col rounded-lg border border-[#DA1E28] bg-[#DA1E28] text-white w-full overflow-hidden transition-all duration-300 select-none cursor-pointer",
      role: "alert",
      "aria-expanded": _ctx.alertExpanded,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.alertExpanded = !_ctx.alertExpanded))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.icon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_v_icon, {
                  icon: _ctx.$props.icon
                }, null, 8, ["icon"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["shrink-0 transition-transform duration-[250ms] font-bold text-[10px]", _ctx.alertExpanded ? 'rotate-180' : 'rotate-0'])
        }, " ▼ ", 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["h-px bg-white/25 mx-3 origin-left transition-[transform,opacity] duration-200 ease-[ease] delay-[0.05s]", _ctx.alertExpanded ? 'scale-x-100 opacity-100' : 'scale-x-0 opacity-0'])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["overflow-hidden transition-[max-height] duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]", _ctx.alertExpanded ? 'max-h-[200px]' : 'max-h-0'])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["px-4 pt-[10px] pb-[14px] flex flex-row items-start gap-[10px] transition-[opacity,transform] duration-[220ms] ease-[ease] delay-[0.08s]", _ctx.alertExpanded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-1'])
        }, [
          (_ctx.icon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_v_icon, {
                  icon: _ctx.$props.icon
                }, null, 8, ["icon"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.title), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                  (_ctx.status)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Folha de monitoramento com pendência: " + _toDisplayString(_ctx.statusLabel) + ". ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.noRecordMessage), 1)
                      ], 64))
                ])
              ])
            ])
          ])
        ], 2)
      ], 2)
    ], 8, _hoisted_2)
  ]))
}